module.exports = __webpack_public_path__ + "img/Annotated_Desert_Ruin.069222bd.png";